import React from 'react';
import InputField from '../../../components/inputs/inputField';
import TextAreaField from '../../../components/inputs/textAreaField';
import SelectField from '../../../components/inputs/selectField';
import ToggleField from '../../../components/inputs/toggleField';
import EventSessionPolls from './polls';
import EventSessionModerators from './moderators';

class App extends React.Component {
	render() {
		const { editedSession, updateSessionField, readOnly } = this.props;
		const { virtualMeetingLink, recordingLink, pageOptions, pageId } = editedSession;
		const selectedPage = pageOptions.find(
			(po) => po._id.toString() == pageId && pageId.toString()
		) || { title: '', _id: null };

		return (
			<div className='sectionBody posRel  p-0 mt-20'>
			<InputField
					label={'Livestream Link'}
					value={virtualMeetingLink}
					disabled={readOnly}
					type="text"
					onChange={(e) => updateSessionField('virtualMeetingLink', e.target.value)}
				/>

				<InputField
					label={'Recording Link'}
					value={recordingLink}
					disabled={readOnly}
					type="text"
					onChange={(e) => updateSessionField('recordingLink', e.target.value)}
				/>
                
                <label className="displayLabe mb-10">
					<div className="flex-ac ">
						<div
							onClick={() => {
								const currentLinks = editedSession.backupVirtualMeetingLinks || [];
								updateSessionField('backupVirtualMeetingLinks', [...currentLinks, '']);
							}}
						>
							<i className="las la-plus-circle mr-10 c-pointer clickable" />
						</div>
                        Add Back-Up Session Links
					</div>
				</label>
                {editedSession.backupVirtualMeetingLinks && editedSession.backupVirtualMeetingLinks.map((link, index) => {
					return (
						<div key={index} className="flex-sb w-100 aic" style={{ gap: '10px' }}>
							<InputField
								label="Back up Session Link"
								value={editedSession.backupVirtualMeetingLinks[index]}
								classes="w-100"
								onChange={(e) => {
									let backuplist = JSON.parse(JSON.stringify(editedSession.backupVirtualMeetingLinks));
									backuplist[index] = e.target.value;
									updateSessionField('backupVirtualMeetingLinks', backuplist);
								}}
							/>
                            <div
								onClick={() => {
									editedSession.backupVirtualMeetingLinks.splice(index, 1);
									updateSessionField('backupVirtualMeetingLinks', editedSession.backupVirtualMeetingLinks);
								}}
								className="flex aic jcc"
								style={{ marginTop: '10px', cursor: 'pointer', minWidth: '24px' }}
							>
								<i className="las la-trash" style={{ color: 'red'}} />
							</div>
						</div>
					);
				})}
                
                <div className="flex-sb w-100">
					<InputField
						label={'Start Offset'}
						value={editedSession.virtualStartOffset}
						disabled={readOnly}
						type="text"
						classes="mr-10 w-100"
						onChange={(e) => updateSessionField('virtualStartOffset', e.target.value)}
					/>

					<InputField
						label={'Stop Offset'}
						value={editedSession.virtualStopOffset}
						disabled={readOnly}
						type="text"
						classes="ml-10 w-100"
						onChange={(e) => updateSessionField('virtualStopOffset', e.target.value)}
					/>
				</div>
			
                <h4 className='blockHeader'>Features</h4>
                <div>
                    <ToggleField
                        label="Enable Chat"
                        checked={editedSession.chatEnabled}
                        icons={false}
                        disabled={readOnly}
                        onChange={(e) => updateSessionField('chatEnabled', !editedSession.chatEnabled)}
                    />

                    <ToggleField
                        label={'Enable Stream Reactions'}
                        checked={editedSession.reactionsEnabled}
                        icons={false}
                        disabled={readOnly}
                        onChange={(e) =>
                            updateSessionField('reactionsEnabled', !editedSession.reactionsEnabled)}
                    />

                    <ToggleField
                        label="Enable Polls"
                        checked={editedSession.pollsEnabled}
                        icons={false}
                        disabled={readOnly}
                        onChange={(e) => updateSessionField('pollsEnabled', !editedSession.pollsEnabled)}
                    />

                    <ToggleField
                        label="Enable Realtime 3D Effects"
                        checked={editedSession.enable3dOverlays}
                        icons={false}
                        disabled={readOnly}
                        onChange={(e) =>
                            updateSessionField('enable3dOverlays', !editedSession.enable3dOverlays)}
                    />
                    {editedSession.enable3dOverlays && (
                        <ToggleField
                            label="Fireworks"
                            checked={editedSession.available3dOverlays.includes('Fireworks')}
                            icons={false}
                            disabled={readOnly}
                            onChange={(e) => {
                                const available3dOverlays = editedSession.available3dOverlays.includes(
                                    'Fireworks'
                                )
                                    ? editedSession.available3dOverlays.filter((o) => o != 'Fireworks')
                                    : [...editedSession.available3dOverlays, 'Fireworks'];
                                updateSessionField('available3dOverlays', available3dOverlays);
                            }}
                        />
                    )}
                    {editedSession.enable3dOverlays && (
                        <ToggleField
                            label={'Snowfall'}
                            checked={editedSession.available3dOverlays.includes('Snow')}
                            icons={false}
                            disabled={readOnly}
                            onChange={(e) => {
                                const available3dOverlays = editedSession.available3dOverlays.includes(
                                    'Snow'
                                )
                                    ? editedSession.available3dOverlays.filter((o) => o != 'Snow')
                                    : [...editedSession.available3dOverlays, 'Snow'];
                                updateSessionField('available3dOverlays', available3dOverlays);
                            }}
                        />
                    )}
                    {editedSession.enable3dOverlays && (
                        <ToggleField
                            label={'Money Drop'}
                            checked={editedSession.available3dOverlays.includes('Money')}
                            icons={false}
                            disabled={readOnly}
                            onChange={(e) => {
                                const available3dOverlays = editedSession.available3dOverlays.includes(
                                    'Money'
                                )
                                    ? editedSession.available3dOverlays.filter((o) => o != 'Money')
                                    : [...editedSession.available3dOverlays, 'Money'];
                                updateSessionField('available3dOverlays', available3dOverlays);
                            }}
                        />
                    )}
                </div>
              
                <h4 className='blockHeader  mt-0'>Polls</h4>
				<div style={{height:400}}>
				<EventSessionPolls
					editedSession={this.props.editedSession}
					event={this.props.event}
					orgId={this.props.orgId}
					readOnly={readOnly}
					loadMoreAttendees={this.props.loadMoreAttendees}
					updateSession={this.updateSession}
					updateSpeakers={this.props.updateSpeakers}
				/>
				</div>
                <h4 className='blockHeader'>Moderators</h4>
				<div style={{height:400}}>
				<EventSessionModerators
					editedSession={this.props.editedSession}
					event={this.props.event}
					orgId={this.props.orgId}
					readOnly={readOnly}
					loadMoreAttendees={this.props.loadMoreAttendees}
					updateSession={this.updateSession}
					updatePolls={this.updatePolls}
					resetPoll={this.resetPoll}
				/>
				</div>
				
			</div>
		);
	}
}

export default App;
